import React from 'react';

const Main = () => {
    return (
        <div>
            <h1>Vista principal</h1>
        </div>
    );
};

export default Main;
